import classNames from 'classnames'
type Props = {
  children: React.ReactNode
  shadowClass?: string
  wrapperClass?: string
  extraClass?: string
  borderClass?: string
  backgroundClass?: string
}

export default function WidgetWrapper({
  children,
  shadowClass,
  extraClass,
  wrapperClass,
  borderClass,
  backgroundClass,
}: Props) {
  return (
    <div
      className={classNames(
        'w-full',
        extraClass ? extraClass : '',
        shadowClass ? shadowClass : 'shadow-none',
        wrapperClass ? wrapperClass : 'p-4',
        borderClass ? borderClass : 'rounded-lg border-[0.5px]',
        backgroundClass && backgroundClass,
      )}
    >
      {children}
    </div>
  )
}
